import { t } from '@lingui/macro';

export const bankersRound = (num: number, dec: number = 0): number => {
  if (dec > 2) {
    throw new Error(t`bankersRound dec parameter should be lower than 3!`);
  }
  // number will be 1 decimal place always if it's less than 1
  if (num < 1) dec = 1;
  const x = num * Math.pow(10, dec);
  const r = Math.round(x);
  const br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
  return br / Math.pow(10, dec);
};
